//============================================================================
// Name        : ConfirmDialog.tsx
// Purpose     : Confirmation dialog component
// Created     : 2019-07-24
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

/** @jsx jsx */ jsx;
import { jsx } from "@emotion/core";
import React from "react";
import { IConfirmDialogProps } from "./types";

class ConfirmDialog extends React.Component<IConfirmDialogProps> {
    getClassName = () => {
        return this.props.show ? "modal show" : "modal fade";
    }

    onPositiveResponse = () => {
        if (this.props.positiveBtnCallback) {
            this.props.positiveBtnCallback();
        }
    }

    onClose = () => {
        if (this.props.negativeBtnCallback) {
            this.props.negativeBtnCallback();
        }
    }

    render() {
        return (
            <div className={this.getClassName()} tabIndex={-1} role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button onClick={this.onClose} type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h1 className="modal-title">{this.props.title}</h1>
                        </div>

                        <div className="modal-body">{this.props.message}</div>

                        <div className="modal-footer" css={{ padding: "15px" }}>
                            <button onClick={this.onPositiveResponse} className="man-btn man-green-btn">{this.props.positiveBtnLbl}</button>
                            <button onClick={this.onClose} className="man-btn">{this.props.negativeBtnLbl}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmDialog;
